import {createApp} from 'vue';
import { createStore } from 'vuex'
import MdPaperViewer from './Viewer.vue';
import MdPaperList from './List.vue';
import MdPaperSearch from './Search.vue';

const store = new createStore({
    state() {
        return {
            recordId: ""
        }
    }
});

const app = createApp({
    components: {
        MdPaperViewer,
        MdPaperList,
        MdPaperSearch
    },
});
app.use(store);
let elements = document.getElementsByClassName('md-paper-app');
for (let el of elements) {
    app.mount(el);
}